/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { formatDistance, showTodayOrTomorrow } from '../../../helper/utils';
import { getDefaultStoreHours, showBopisDate } from '../../../helper/timeZoneUtils';
import { IDS } from '../../../../automationTestIds';

const {
  string, shape, number, object, bool
} = proptypes;

const InStockNearByStore = ({ nearByStoreLocation, pickupStoreHours = null, isCartTiles = false, deliveryTimeline = null }) => {
  // Need to use the nearbyStoreHours from the API once in place and remove the useStore .
  // Until then we are taking storeHours from the experience-context.
  let { storeHours } = useStore();
  if (!storeHours) {
    storeHours = getDefaultStoreHours();
  }

  const pickupStoreHoursWithTZ = isCartTiles ? pickupStoreHours
    : { ...storeHours, ...pickupStoreHours };

  const renderBopisTimeline = () => (deliveryTimeline ? (
    showTodayOrTomorrow(
      null,
      true,
      deliveryTimeline,
      null
    )
  ) : (
    showBopisDate(pickupStoreHoursWithTZ, true)
  ));

  return (
    <div>
      <TileHead title="Pickup Nearby" automationId={IDS.LABEL.pickupNearByLabel} />
      <div data-testid="ffm-details-row" className="sui-pt-2">
        <Typography variant="body-base" weight="bold" component="div">
          <div
            className="sui-font-bold sui-pb-1 sui-min-h-[24px]"
            data-testid="pickupTimeline"
            data-automation-id={IDS.ETA.pickupNearByETA}
          >
            {renderBopisTimeline()}
          </div>
        </Typography>
        <Typography variant="body-base" component="div">
          <div className="sui-min-h-[24px] sui-line-clamp-1 sui-break-all sui-m-w-[100%]">
            <span
              data-testid="fulfillment-qty-row"
              data-automation-id={IDS.QTY.pickupNearByQty}
            >
              <span className="sui-text-success">{'In stock '}</span>
              {`${formatDistance(nearByStoreLocation?.distance)} mi away`}
            </span>
          </div>
        </Typography>

      </div>
      <TileFooter>
        <span className="sui-font-bold sui-text-success">FREE</span>
      </TileFooter>
    </div>

  );
};
InStockNearByStore.propTypes = {
  nearByStoreLocation: shape({
    storeName: string,
    distance: number
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pickupStoreHours: object,
  isCartTiles: bool,
  deliveryTimeline: string
};

export { InStockNearByStore };
